import { DefaultFooter } from '@ant-design/pro-components';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{ background: 'none' }}
      copyright={`${new Date().getFullYear()} PayPal 账号管理系统`}
      links={[]}
    />
  );
};

export default Footer;
